// Generated by ReScript, PLEASE EDIT WITH CARE

import * as View from "../../primitives/View.res.js";
import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:10"
  },
  alignStart: {
    "alignItems-kGNEyG": "alignItems-x1cy8zhl",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:16"
  },
  alignEnd: {
    "alignItems-kGNEyG": "alignItems-xuk3077",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:19"
  },
  alignCenter: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:22"
  },
  alignSpaceBetween: {
    "alignItems-kGNEyG": "alignItems-x1pha0wt",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:25"
  },
  alignStretch: {
    "alignItems-kGNEyG": "alignItems-x1qjc9v5",
    $$css: "wino-gc:src/resources/layout-and-structure/Stack.res.js:28"
  }
};
function styleProps(space, align) {
  let gapValue = Spaces.toPx(space);
  return Stylex.props(styles.root, {
    columnGap: `max(calc(` + gapValue + ` / 2), ` + "4px" + `)`,
    rowGap: gapValue
  }, align === "end" ? styles.alignEnd : align === "start" ? styles.alignStart : align === "center" ? styles.alignCenter : align === "spaceBetween" ? styles.alignSpaceBetween : styles.alignStretch);
}
function Stack(props) {
  let __align = props.align;
  let __space = props.space;
  let space = __space !== undefined ? __space : "xxsmall";
  let align = __align !== undefined ? __align : "stretch";
  let children = React.Children.toArray(props.children).filter(child => child !== null);
  let childrenLength = children.length;
  if (childrenLength <= 0) {
    return null;
  }
  let match = styleProps(space, align);
  return JsxRuntime.jsx(View.make, {
    children: children,
    className: match.className,
    style: match.style
  });
}
let make = Stack;
export { make };
/* styles Not a pure module */